export function removeRegArray(coddel, regs) {
  var objDel = regs.find(i => i.id == coddel);
  var index = regs.indexOf(objDel);
  if (index > -1) {
    regs.splice(index, 1);
  }
  return regs;
}

export function validarEmail(email) {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}

// casas: casas decimais do valor (ex.: licitação com preço em 4 casas); padrão 2
export function formatReal(val, casas = 2) {
  const num = Number(val);
  if (val === null || val === undefined || isNaN(num)) return 'R$ 0,00';
  const dec = Number.isInteger(casas) && casas >= 0 && casas <= 6 ? casas : 2;
  var formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: dec,
    maximumFractionDigits: dec
  });
  return formatter.format(num);
}

/**
 * Converte para número um valor vindo dos portais, que chega em pt-BR e às vezes
 * com símbolo de moeda ("R$ 1.234,56", "1.234,56", "1234.56", 1234.56).
 * Devolve 0 quando não há número reconhecível (ex.: "Sigiloso", "-", vazio).
 */
export function parseValorBR(valor) {
  if (valor === null || valor === undefined || valor === '') return 0;
  if (typeof valor === 'number') return isNaN(valor) ? 0 : valor;

  let txt = String(valor).replace(/[^\d,.-]/g, '').trim();
  if (!txt) return 0;

  const temVirgula = txt.includes(',');
  const temPonto = txt.includes('.');

  if (temVirgula && temPonto) {
    // formato pt-BR completo: ponto é milhar, vírgula é decimal
    txt = txt.replace(/\./g, '').replace(',', '.');
  } else if (temVirgula) {
    txt = txt.replace(',', '.');
  } else if (temPonto) {
    // ponto sozinho pode ser milhar ("1.234") ou decimal ("1234.56"):
    // com exatamente 3 dígitos depois do último ponto, é separador de milhar
    const partes = txt.split('.');
    const ultima = partes[partes.length - 1];
    if (partes.length > 2 || ultima.length === 3) txt = partes.join('');
  }

  const num = parseFloat(txt);
  return isNaN(num) ? 0 : num;
}

export async function showAlert(icon, msg) {
  // O SweetAlert tem uma única instância: se um loading/toast ainda está na
  // animação de fechamento (closeLoading logo antes, por exemplo), o fire
  // seguinte é descartado e o alerta nunca aparece. Fecha o que estiver aberto
  // e só abre depois da animação — 250ms cobre o fechamento padrão.
  try { window.Swal.close(); } catch (e) { /* nada aberto */ }
  await new Promise((r) => setTimeout(r, 250));

  window.Swal.fire({
    icon: icon,
    title: msg,
    padding: '2em',
    allowOutsideClick: false,
  });
}

export async function showToast(icon, msg, xpos = 'bottom-end', xtime = 3000) {
  let toastIcon = icon;
  if (msg && typeof msg === 'string' && msg.toLowerCase().includes('erro')) {
    toastIcon = 'error';
  }
  const toast = window.Swal.mixin({
    toast: true,
    position: xpos,
    showConfirmButton: false,
    timer: xtime,
    padding: '2em'
  });
  toast.fire({
    icon: toastIcon,
    title: msg,
    padding: '2em'
  });
}

export function showLoading(msg) {
  window.Swal.fire({
    title: 'AGUARDE',
    html: msg,
    allowOutsideClick: false,
    didOpen: () => {
      window.Swal.showLoading();
    },
    willClose: () => { }
  });
}

export function closeLoading() {
  window.Swal.close();
}

export function calcularPorcentagem(total, valor) {
  if (total === 0) {
    throw new Error("O total não pode ser zero.");
  }
  return ((valor / total) * 100).toFixed(2);
}

export async function showConfirm(icon, title, msg) {
  try {
    const result = await window.Swal.fire({
      icon: icon,
      title: title,
      html: msg,
      showCancelButton: true,
      confirmButtonText: 'SIM',
      cancelButtonText: 'CANCELAR',
      padding: '2em',
    });

    return result.isConfirmed;
  } catch (error) {
    console.error('Erro ao exibir confirmação:', error);
    return false;
  }
}

export function maskCNPJ(cnpj) {
  const digits = cnpj.replace(/\D+/g, '');

  return digits
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2}\.\d{3})(\d)/, '$1.$2')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .substring(0, 18);
}

export function isJSON(obj) {
  try {
    if (typeof obj === 'string') {
      JSON.parse(obj);
    } else if (typeof obj === 'object' && obj !== null) {
      JSON.stringify(obj);
    } else {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
}
